import { useParentSize } from "@visx/responsive";

export interface UseChartBoxOptions {
  debounceTime?: number;
  fallbackWidth?: number;
}

export interface UseChartBoxResult {
  parentRef: (node: HTMLDivElement | null) => void;
  width: number;
  height: number;
}

export function useChartBox({
  debounceTime = 10,
  fallbackWidth = 820,
}: UseChartBoxOptions = {}): UseChartBoxResult {
  const { parentRef, width: measuredWidth } = useParentSize({
    debounceTime,
    ignoreDimensions: "height",
  });
  const width = measuredWidth > 0 ? measuredWidth : fallbackWidth;
  const height = width < 480 ? 260 : 340;
  return { parentRef, width, height };
}
